import { render, staticRenderFns } from "./AdminDeliverableForms.vue?vue&type=template&id=41285143&scoped=true&"
import script from "./AdminDeliverableForms.vue?vue&type=script&lang=js&"
export * from "./AdminDeliverableForms.vue?vue&type=script&lang=js&"
import style0 from "./AdminDeliverableForms.vue?vue&type=style&index=0&id=41285143&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41285143",
  null
  
)

export default component.exports